module.exports = __webpack_public_path__ + "static/media/instant_drinks.16d34565.jpg";